import { PackageDTO } from '../../dto';
import { MgPackageClassCode, Unit } from '@retail/products/types';

export class Package {
  gtinCode?: string;
  unit: Unit;
  classCode: MgPackageClassCode;

  constructor(dto: PackageDTO) {
    this.gtinCode = dto.gtinCode;
    this.unit = Unit.fromDto(dto.unit);
    this.classCode = dto.classCode;
  }

  static fromDto(dto: PackageDTO): Package {
    return new Package(dto);
  }
}
